const ALLOWED_HOSTNAMES = [
    'fulfillment.shipbob.com',
    'operators.shipbob.com',
    'resources.shipbob.com',
    'product.shipbob.com',
    'www.shipbob.com',
    'go.shipbob.com',
    'shipbob-develop.go-vip.net',
    'shipbob.vipdev.lndo.site',
    'hs-sites.com',
    'hubspotpreview-na1.com'
];

const isAllowedHost = (hostname) => ALLOWED_HOSTNAMES.some((allowed) => hostname.includes(allowed));

export const JSProtect = (canRun) => {
    const { hostname } = window.location;

    if (!isAllowedHost(hostname)) {
        console.warn(`JSProtect: hostname "${hostname}" not in allowlist; skipping registration.`);
        return;
    }

    return canRun();
};